import { render, staticRenderFns } from "./AdvancedDashboard.vue?vue&type=template&id=5d534d1a"
import script from "./AdvancedDashboard.vue?vue&type=script&lang=js"
export * from "./AdvancedDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdvancedDashboard.vue?vue&type=style&index=0&id=5d534d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports